class LSIPModal {
	constructor(modalId, dontShowAgainCheckboxId) {
		this.modalId = modalId;
		this.dontShowAgainCheckboxId = dontShowAgainCheckboxId;
		this.localStorageKey = 'lsip-modal-skip';
	}

	shouldSkip() {
		return localStorage.getItem(this.localStorageKey) === 'true';
	}

	show(onConfirm, onCancel) {
		// Use a small delay to ensure DOM is ready
		setTimeout(() => {
			const modal = document.getElementById(this.modalId);
			if (!modal) {
				console.warn(`Modal #${this.modalId} not found in DOM`);
				if (onConfirm) onConfirm();
				return;
			}

			const modalButton = modal.querySelector('.btn');
			const modalCloseBtn = modal.querySelector('.modal-close-btn');
			const modalContent = modal.querySelector('.modal-content');
			
			if (!modalButton || !modalCloseBtn || !modalContent) {
				console.warn('Modal elements not found:', {
					button: !!modalButton,
					closeBtn: !!modalCloseBtn,
					content: !!modalContent,
					modal: !!modal
				});
				if (onConfirm) onConfirm();
				return;
			}

			// Ensure modal is visible
			$('body').addClass('modal-active');
			modal.classList.add('show');
			
			// Force a reflow to ensure the show class is applied
			void modal.offsetHeight;

			let isClosed = false;
			let observer = null;

			const closeModal = () => {
				if (isClosed) return;
				isClosed = true;

				this.hide();

				// Clean up event listeners
				if (modalButton) {
					modalButton.removeEventListener('click', handleButtonClick);
				}
				if (modalCloseBtn) {
					modalCloseBtn.removeEventListener('click', handleCloseClick);
				}
				modal.removeEventListener('click', handleBackdropClick);
				if (observer) {
					observer.disconnect();
				}
			};

			const confirmAndClose = () => {
				closeModal();

				const dontShowAgain = modal.querySelector(
					`#${this.dontShowAgainCheckboxId}`
				);
				if (dontShowAgain && dontShowAgain.checked) {
					localStorage.setItem(this.localStorageKey, 'true');
				}

				if (onConfirm) onConfirm();
			};

			const cancelAndClose = () => {
				closeModal();
				if (onCancel) onCancel();
			};

			const handleButtonClick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				confirmAndClose();
			};

			const handleCloseClick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				cancelAndClose();
			};

			// Handle clicking outside modal (on backdrop)
			const handleBackdropClick = (e) => {
				// Only trigger if clicking directly on the modal (backdrop), not on modal-content
				if (e.target === modal && !modalContent.contains(e.target)) {
					cancelAndClose();
				}
			};

			// Watch for when modal is closed by global handler (clicking outside)
			observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (
						mutation.type === 'attributes' &&
						mutation.attributeName === 'class' &&
						!modal.classList.contains('show') &&
						!isClosed
					) {
						// Modal was closed by global handler, cancel (don't check LSVP)
						cancelAndClose();
					}
				});
			});

			observer.observe(modal, {
				attributes: true,
				attributeFilter: ['class'],
			});

			modalButton.addEventListener('click', handleButtonClick);
			modalCloseBtn.addEventListener('click', handleCloseClick);
			modal.addEventListener('click', handleBackdropClick);
		}, 10);
	}

	hide() {
		const modal = document.getElementById(this.modalId);
		if (modal) {
			$('body').removeClass('modal-active');
			modal.classList.remove('show');
		}
	}
}

export default LSIPModal;

